document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#formclient');

    const handleSkipEmailStep = () => {
        const pushKey = form.dataset.id + '-' + (form.dataset.offerType ? form.dataset.offerType : 'generic');
        const skipBtns = document.querySelectorAll('.js-no-email');

        skipBtns && skipBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                window.sessionLayer.leadHandler.push(pushKey, {
                    Email: ''
                })
            })
        })
    }

    form && window.addEventListener('FormClientRendered', handleSkipEmailStep)

});